<!-- 収集運搬業者詳細 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card>
      <v-card-title>収集運搬業者詳細</v-card-title>
      <v-card
        class="mx-auto"
        max-width="600"
      >
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-content class="text-h5">
                {{ transport.name }}
              </v-list-item-content>
              <v-list-item-subtitle> {{ transport.subscriber_number }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <div v-if="transport.zip_code">〒{{ transport.zip_code }}</div>
              {{ transport.address }}
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content> {{ transport.phone_number }} </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-fax</v-icon>
            </v-list-item-icon>
            <v-list-item-content> {{ transport.fax_number }} </v-list-item-content>
          </v-list-item>
        </v-card-text>
      </v-card>

      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="transport.locations"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.location_name`]="{ item }">
            <span :title="item.location_name">{{ item.location_name | truncate(15) }}</span>
          </template>
          <template v-slot:[`item.address`]="{ item }">
            <span :title="item.address">
              {{ item.address | truncate(20) }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-text>
        <v-data-table
          :headers="tenantTableHeaders"
          :items="transport.tenants"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.location_name`]="{ item }">
            <span :title="item.name">{{ item.name | truncate(15) }}</span>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <span v-if="item.deleted" style="color:#FF0000">
              ●
            </span>
            {{ item.created_at | unix_datetime_format }}
          </template>
        </v-data-table>
        <v-row>
          <v-col cols="6">
            <v-checkbox
              v-model="transport.use_jwnet"
              dense
              label="JWNET対象"
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-btn
          :disabled="transport.use_jwnet"
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="showButtonClickEvent(transport)"
        >
          ルート確認
        </v-btn>
        <v-btn
          color="primary"
          @click="registerButtonClickEvent"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
    <!-- /ダイアログ -->
    <transport-routes-show-dialog
      :enable-dialog="enableRoutesDialog"
      :target-id="targetId"
      @closeEvent="closeRoutesDialog"
      @registerEvent="routesCallback"
    />
    <!-- ダイアログ -->
  </v-container>
</template>

<script>
import { mapActions} from 'vuex'
import Confirm from '../../../../components/Confirm'
import TransportRoutesShowDialog from '../dialogs/TransportRoutesShowDialog'
export default {
  name: 'AdminMasterTransportShow',
  components: {Confirm, TransportRoutesShowDialog},
  filters: {
  },
  mixins: [],
  data () {
    return {
      targetId: null,
      enableRoutesDialog: false,
      breadcrumbs: [
        { text: '収集運搬業者一覧', disabled: false, to: '/admin/masters/transports', exact: true },
        { text: '収集運搬業者詳細', disabled: true, to: '' },
      ],
      tableHeaders: [
        { value: 'location_code', text: '事業場コード' },
        { value: 'location_name', text: '事業場名称' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '所在地' },
        { value: 'phone_number', text: '電話番号' },
        { text: '', value: 'editable', align: 'end' },
      ],
      tenantTableHeaders: [
        { value: 'code', text: 'テナントコード' },
        { value: 'name', text: 'テナント名' },
        { value: 'supervisor_name', text: '担当者名' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'created_at', text: '登録日時' },
      ],
      transport: {}
    }
  },
  created() {
    this.fetchTransport({ id: this.$route.params.id }).then((content) => {
      this.transport = content
    })
  },
  methods: {
     ...mapActions('AdminMasterTransport', {
      fetchTransport: 'show',
      updateTransport: 'update',
      deleteTransport: 'destroy',
    }),
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableRoutesDialog = true
    },
    closeRoutesDialog () {
      this.enableRoutesDialog = false;
    },
    routesCallback (forms) {
      this.closeRoutesDialog()
    },
    registerButtonClickEvent () {
      let params = {
        use_jwnet: this.transport.use_jwnet
      }
      if (this.transport.use_jwnet === false) {
        let modalOption = {
          title: "更新",
          message: "JWNET対象をONからOFF変更している場合に全てのルートが非表示設定されます。よろしいですか",
          options: { width: 450, titleColor: "red", isCancelButton: true },
        }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.updateTransport({ id: this.transport.id, params: params }).then(() => {
              this.$router.push( { name: 'AdminMasterTransports' } )
            })
          }
        })
      } else {
        this.updateTransport({ id: this.transport.id, params: params }).then(() => {
          this.$router.push( { name: 'AdminMasterTransports' } )
        })
      }
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteTransport({id: this.$route.params.id }).then(() =>{
            this.$router.push({name: 'AdminMasterTransports'})
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
